// src/config/emailConfig.js
export const EMAILJS = {
  approvals: {
    // === EmailJS ACCOUNT A (approvals/notifications) ===
    publicKey: "ICFlS_3sRPTHIsl2p",    // from Account A
    serviceId: "service_1qr2jyy",    // in Account A
    approvalTemplateId: "template_vt9ztmd",   // new request -> approver | template_room_approval_request
    decisionTemplateId: "template_5gwc3io",   // approve/reject -> requester | template_room_approval_decision 
    approverEmail: "support-eartes@uevora.pt",                 // approver inbox
  },

  contact: {
    // === EmailJS ACCOUNT B (contact/support) ===
    publicKey: "yu8CHeqjt9-cpCPlM",      // from Account B
    serviceId: "service_oy8j4od",      // in Account B
    contactTemplateId: "template_leyy34g",   // contact form -> support | contact_support 
    supportEmail: "support-eartes@uevora.pt",        // support inbox
  },
};

